import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as _ from 'lodash';

/** Single app-wide registry for custom image-modal host (TR-003). */
@Injectable({ providedIn: 'root' })
export class ModalService {
    private modals: any[] = [];
    modalOpenClose$: Subject<Boolean>;

    add(modal: any) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        let modalToRemove = _.find(this.modals, m => m.id === id);
        if (!modalToRemove){
            console.error('ModalService.remove() >> Can\'t find a modal with id:' + id);
            return;
        }
        this.modals = _.without(this.modals, modalToRemove);
    }

    open(id: string) {
        // open modal specified by id
        let modal = _.find(this.modals, m => m.id === id);
        if (!modal){
            console.error('ModalService.open() >> Can\'t find a modal  with id:' + id);
            return;
        }
        modal.open();
        this.modalAction(true);
    }

    close(id: string) {
        // close modal specified by id
        let modal = _.find(this.modals, m => m.id === id);
        if (!modal){
            console.error('ModalService.close() >> Can\'t find a modal  with id:' + id);
            return;
        }
        modal.close();
        this.modalAction(false);
    }

    modalAction(open:Boolean){
        if (!this.modalOpenClose$) {
            this.modalOpenClose$ = new Subject<Boolean>();
        }
        this.modalOpenClose$.next(open);
    }

    subscribeToModalOpenClose(): Observable<Boolean> {
        if (!this.modalOpenClose$)
            this.modalOpenClose$ = new Subject<Boolean>();
        return this.modalOpenClose$.asObservable();
    }

    modalExists(id: string): Boolean{
        let modal = _.find(this.modals, m => m.id === id);
        if (!modal)
            return false;
        return true;
    }
}
